import { render, staticRenderFns } from "./AccountRegistration.vue?vue&type=template&id=a41e4812&"
import script from "./AccountRegistration.vue?vue&type=script&lang=js&"
export * from "./AccountRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports